import { useEffect, useRef } from 'react';
import { useKernel } from './AIKernel';

export const useBehaviorSensor = (symbol, weightMultiplier = 1) => {
    const { reportBehavior } = useKernel();
    const ref = useRef(null);

    useEffect(() => {
        let startTime = 0;
        
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                // User is looking at this element
                startTime = Date.now();
            } else {
                // User scrolled away, calculate dwell time
                if (startTime > 0) {
                    const dwellTimeSeconds = (Date.now() - startTime) / 1000;
                    // Only record if they actually paused to look (> 2 seconds)
                    if (dwellTimeSeconds > 2) {
                        const weight = dwellTimeSeconds * weightMultiplier;
                        reportBehavior(symbol, weight, 'interest');
                    }
                    startTime = 0;
                }
            }
        }, { threshold: 0.6 }); // Triggers when 60% of element is visible

        if (ref.current) observer.observe(ref.current);

        return () => {
            if (ref.current) observer.unobserve(ref.current);
        };
    }, [symbol, weightMultiplier, reportBehavior]);

    return ref; // Attach this to the component you want to track
};